import { Component } from '@angular/core';

@Component({
  selector: 'app-adherence-profiler',
  templateUrl: './adherence-profiler.component.html',
  styleUrl: './adherence-profiler.component.scss'
})
export class AdherenceProfilerComponent {
complianceRuleEnabled = true;

  // Track rule enabled state per patient
  private ruleState: { [patientId: number]: boolean } = {};

  isRuleEnabled(patient: { id: number }): boolean {
    return !!this.ruleState[patient.id];
  }

  toggleRule(patient: { id: number }): void {
    this.ruleState[patient.id] = !this.isRuleEnabled(patient);
    // Here you could also call an API to persist the rule state
  }
}
